(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-collection-page]');
    if (!page) return;
    var toggle = page.querySelector('[data-filter-toggle]');
    var panel = page.querySelector('[data-filter-panel]');
    var close = page.querySelector('[data-filter-close]');
    var sort = page.querySelector('[data-sort-select]');
    function setPanel(open) {
      if (!panel || !toggle) return;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    }
    if (toggle) toggle.addEventListener('click', function () { setPanel(panel.hidden); });
    if (close) close.addEventListener('click', function () { setPanel(false); });
    if (sort) sort.addEventListener('change', function () { page.querySelector('#CollectionFiltersForm').submit(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function initGallery(root) {
      if (!root || root.dataset.galleryReady === 'true') return;
      root.dataset.galleryReady = 'true';

      var slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
      var previous = root.querySelector('[data-gallery-prev]');
      var next = root.querySelector('[data-gallery-next]');
      var counter = root.querySelector('[data-gallery-current]');
      var dialog = root.querySelector('[data-gallery-dialog]');
      var dialogImage = root.querySelector('[data-gallery-dialog-image]');
      var close = root.querySelector('[data-gallery-close]');
      var activeIndex = 0;

      function show(index) {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        thumbs.forEach(function (thumb, thumbIndex) {
          var active = thumbIndex === activeIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (counter) counter.textContent = String(activeIndex + 1);
        if (thumbs[activeIndex]) thumbs[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      thumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { show(index); }); });
      if (previous) previous.addEventListener('click', function () { show(activeIndex - 1); });
      if (next) next.addEventListener('click', function () { show(activeIndex + 1); });
      slides.forEach(function (slide, index) {
        slide.addEventListener('click', function () {
          show(index);
          if (!dialog || !dialogImage) return;
          var image = slide.querySelector('img');
          dialogImage.src = slide.dataset.fullSrc || (image && image.currentSrc) || '';
          dialogImage.alt = image ? image.alt : '';
          if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
        });
      });
      if (close && dialog) close.addEventListener('click', function () { dialog.close(); });
      if (dialog) dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
      root.addEventListener('keydown', function (event) { if (event.key === 'ArrowLeft') show(activeIndex - 1); if (event.key === 'ArrowRight') show(activeIndex + 1); });
      show(0);
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-product-gallery]').forEach(initGallery); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); }); else initAll(document);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
